import { cx } from '@platform/core/lib/cx';
import { Icon } from './Icon';
import type { IIconButtonProps } from './IIconButtonProps';

const ICON_SIZE = { sm: 14, md: 16, lg: 16 } as const;

/**
 * Іконкова кнопка 32×32 (sm 28, lg 34), радіус 8px або кругла; наведення — рамка акценту, натиснута — --accent-soft з акцентом.
 * Підпис обов'язковий: aria-label і підказка title (UIUX/foundations/accessibility).
 */
export function IconButton({ icon, label, size = 'md', variant = 'default', round = false, pressed, badge, iconSize, filled, className, title, type = 'button', ...rest }: IIconButtonProps) {
  return (
    <button type={type} className={cx('icon-btn', `icon-btn--${size}`, variant !== 'default' && `icon-btn--${variant}`, round && 'icon-btn--round', className)}
      aria-label={label} title={title ?? label} aria-pressed={pressed} {...rest}>
      <Icon name={icon} size={iconSize ?? ICON_SIZE[size]} filled={filled} />
      {badge !== undefined && badge !== null && badge !== '' && <span className="icon-btn__badge">{badge}</span>}
    </button>
  );
}
